<template>
    <div class="home">
        <Nav/>
        <div class="banner-img">
            <img src="../assets/08.png"/>
        </div>
        <div class="main">
            <div class="pro-info">
                <div>
                    <h3>产品描述</h3>
                    <div class="mt25">为集团全体员工提供的用于个人消费用途的信用贷款</div>
                </div>
                <div>
                    <h3>申贷条件</h3>
                    <div class="mt25">① 申请员工年龄不超过55周岁；</div>

                    <div>② 人行征信报告贷款当前无逾期、近24个月贷款逾期次数不超过6次，连续逾期期数不超过3期，无风险提示信息；</div>

                    <div>③ 限中国大陆员工；</div>

                    <div>④ 不在民间借贷黑名单以及全国法院失信被执行人名单内，无未结经济纠纷案件；</div>

                    <div>⑤ 申请员工需转正，试用期员工不得申请；</div>

                    <div>⑥ 金蝶软件（中国）有限公司RBU各子分公司、金蝶蝶金云计算有限公司RBU各子分公司员工需工作满2年（含）以上。</div>
                </div>
                <div>
                    <h3>申贷流程</h3>
                    <div class="mt25">云之家（我的-团队-切换到金蝶国际软件集团）——更多应用——智能审批——员员贷——员员贷申请页面。</div>
                </div>
                <div>
                    <h3>所需材料</h3>
                    <div class="mt25">身份证、详细版人行征信报告、银行卡、资产证明（如有）</div>
                </div>
                <div>
                    <h3>贷款费用</h3>
                    <div class="mt25">年化8%~14.4%</div>
                    <div>注：若有购房合同证明，利率低至年化4.275%</div>
                </div>
                <div>
                    <h3>还款和计息方式</h3>
                    <div class="mt25">等额本息、等额本金、按月付息到期还本、按月付息按年还本</div>
                </div>
                <div>
                    <h3>逾期处理方式</h3>
                    <div class="mt25">逾期罚息：每日收取罚息，以逾期本金为基数，罚息利率为贷款利率上浮50%</div>
                </div>
                <div>
                    <h3>业务投诉电话</h3>
                    <div class="mt25">4008-830-822</div>
                </div>
            </div>
            <Foot class="mt100"/>
        </div>
    </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  props: {},
  methods: {
    effectiveLoanEvent() {
      this.$router.push({ path: `/permission/index?${+new Date()}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .home {
        .banner-img {
            img {
                width: 100%;
            }
        }
        .main {
            height: 729px;
            padding-bottom: 100px;
            .pro-info {
                position: relative;
                margin-left: 25%;
                .black-bl {
                    position: absolute;
                    top: -17px;
                    color: rgba(51, 47, 43, 1);
                    font-weight: 500;
                    font-size: 26px;
                }
                div {
                    font-size: 13px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: rgba(142, 142, 142, 1);
                    line-height: 26px;
                }
                .mt25 {
                    margin-top: 25px;
                }
                h3 {
                    padding-top: 70px;
                    font-size: 20px;
                    color: rgba(51, 47, 43, 1);
                }
                .mt40 {
                    margin-top: 40px;
                }
                .ml60 {
                    margin-left: 3.125%;
                }
            }
        }

    }

</style>
